import script from "./SubscribeBlurbView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeBlurbView.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeBlurbView.vue?vue&type=style&index=0&id=207d37c4&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-207d37c4"]])

export default __exports__